import { AppContextProvider } from "components/AppContextProvider";
import Routes from "components/Routes";
import { UserContextProvider } from "components/UserContextProvider";
import firebase from "firebase-tools";
import { BrowserRouter as Router } from "react-router-dom";
import { ThemeProvider } from "styled-components";
import { theme } from "theme";
import "./App.css";

import { UserProvider } from "auth";

const App = () => {
  return (
    <Router>
      <ThemeProvider theme={theme}>
        <AppContextProvider>
          <UserProvider>
            <UserContextProvider>
              <Routes />
            </UserContextProvider>
          </UserProvider>
        </AppContextProvider>
      </ThemeProvider>
    </Router>
  );
};

export default App;
